<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form
        ref="formValidate"
        :inline="true"
        :model="params"
        label-position="right"
      >
        <el-form-item :label="$t('user.account')" prop="loginName">
          <el-input
            v-model.trim="params.loginName"
            style="width: 200px"
            :placeholder="this.$t('user.account')"
            :clearable="true"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="commQuery" icon="el-icon-search">{{
          $t('common.search')
        }}</el-button>
      </el-form>
    </div>

    <div class="black_panel_cla">
      <div class="header-button-bar">
        <ZkButtonGroup
          :isLoadGroupName="true"
          @addIntegratorsUser="addIntegratorsUser"
          groupName="addIntegratorsUser"
          :isGroup="true"
        ></ZkButtonGroup>
      </div>
      <el-table :data="interTable" style="width: 100%">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          prop="loginName"
          :label="this.$t('user.account')"
        ></el-table-column>
        <el-table-column prop="name" :label="this.$t('user.userName')">
          <template slot-scope="scope">
            {{ isEmpty(scope.row.name) }}
          </template></el-table-column
        >
        <el-table-column prop="email" :label="this.$t('user.email')">
          <template slot-scope="scope">
            {{ scope.row.email | emailFormat }}
          </template>
        </el-table-column>
        <!--<el-table-column prop="phone"
                         :label="this.$t('user.phone')"></el-table-column>-->
        <el-table-column
          prop="createTimeFormat"
          :label="this.$t('user.registerTime')"
        ></el-table-column>
        <el-table-column prop="status" :label="this.$t('user.status')">
          <template slot-scope="scope">
            <zk-dictionary-transform
              :value="scope.row.status"
              type="status"
              :key="scope.row.id + scope.row.status"
            ></zk-dictionary-transform>
          </template>
        </el-table-column>
        <el-table-column min-width="180px" :label="this.$t('common.operation')">
          <template slot-scope="scope">
            <ZkButtonGroup
              :key="scope.row.id + scope.row.status"
              :isLoadGroupName="true"
              @updateIntergators="updateIntergators"
              @deleteIntergators="deleteIntergators"
              @intergatorsDetails="intergatorsDetails"
              @resetPassword="resetPassword"
              @unfreeze="unfreeze"
              @freeze="freeze"
              :event="
                scope.row.status === 1
                  ? [
                      'updateIntergators',
                      'intergatorsDetails',
                      'deleteIntergators',
                      'resetPassword',
                      'freeze'
                    ]
                  : [
                      'updateIntergators',
                      'deleteIntergators',
                      'intergatorsDetails',
                      'resetPassword',
                      'unfreeze'
                    ]
              "
              :showTip="true"
              :params="scope.row"
              :showText="false"
              size="mini"
              groupName="integratorsOperation"
              :isGroup="true"
            ></ZkButtonGroup>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="pageSizeChange(arguments[0], commQuery)"
          @current-change="curPageChange(arguments[0], commQuery)"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="pager.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :append-to-body="true"
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="50%"
    >
      <el-form
        ref="formValidate"
        :model="userform"
        :rules="rules"
        label-width="180px"
        label-position="right"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('user.account')" prop="loginName">
              <el-input
                v-model="userform.loginName"
                :placeholder="$t('user.inputAccount')"
                :disabled="isUpdate || idDetails"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('user.userName')" prop="name">
              <el-input
                :disabled="idDetails"
                v-model.trim="userform.name"
                :placeholder="$t('user.inputName')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isUpdate && !idDetails">
          <el-col :span="12">
            <el-form-item
              :label="$t('user.password')"
              prop="password"
              v-if="!isUpdate"
            >
              <el-input
                type="password"
                :disabled="idDetails"
                v-model.trim="userform.password"
                :placeholder="$t('user.inputPwd')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('user.confirmedPwd')"
              prop="secondPwd"
              v-if="!isUpdate"
            >
              <el-input
                type="password"
                :disabled="idDetails"
                v-model.trim="userform.secondPwd"
                :placeholder="$t('user.input2ndPwd')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('user.email')" prop="email">
              <el-input
                :disabled="idDetails"
                v-model.trim="userform.email"
                :placeholder="$t('user.inputEmail')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('user.phone')" prop="phone">
              <el-input
                :disabled="idDetails"
                v-model.trim="userform.phone"
                :placeholder="$t('user.inputPhone')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('user.status')" prop="status">
              <zk-dictionary-select
                :disabled="idDetails"
                type="status"
                v-model="userform.status"
                :placeholder="$t('common.select')"
              ></zk-dictionary-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary" @click.stop="submitSave">{{
          $t('common.confirm')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as accountApi from '@/services/adminAccountApi.js'
import { Loading } from 'element-ui'
import {
  validatorEmailRule,
  validatorPhoneRule
} from '@/utils/validatorRule.js'
export default {
  data() {
    let checkRepasswd = (rule, value, callback) => {
      if (!(value + '')) {
        return callback(new Error(this.$t('user.input2ndPwd')))
      } else if (value !== this.userform.password) {
        return callback(new Error(this.$t('user.pwdInconsistent')))
      } else {
        callback()
      }
    }
    let checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('user.selectStatus')))
      } else {
        callback()
      }
    }
    let rules = {
      loginName: this.validatorInputEmptyRule(true, 30),
      password: this.validatorPasswordRule(true),
      secondPwd: [
        { required: true, validator: checkRepasswd, trigger: 'blur' }
      ],
      status: [{ required: true, validator: checkStatus, trigger: 'blur' }],
      email: validatorEmailRule(false),
      phone: validatorPhoneRule(false),
      row: []
    }
    return {
      rules,
      interTable: [],
      dialogTitle: '',
      dialogFormVisible: false,
      isUpdate: true,
      idDetails: false,
      loadingInstance: null,
      currentRow: null,
      params: {
        loginName: ''
      },
      userform: {
        loginName: '',
        name: '',
        password: '',
        secondPwd: '',
        phone: '',
        email: '',
        status: 1
      },
      newPassword: ''
    }
  },
  mounted() {
    this.commQuery()
  },
  methods: {
    submitSave() {
      if (this.idDetails) {
        this.dialogFormVisible = false
        return false
      } else if (this.isUpdate) {
        // 更改
        let params = this.userform

        delete params.password
        delete params.secondPwd

        this.$refs.formValidate.validate(valid => {
          if (valid) {
          }
        })
      } else {
        // 新增
        let params = this.userform
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            accountApi
              .addIntegratorsAccount(params)
              .then(data => {
                this.dialogFormVisible = false
                if (data.code === '00000000') {
                  this.commQuery()
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => {
                this.errorMessage()
              })
          }
        })
      }
    },
    intergatorsDetails(row) {
      this.dialogTitle = this.$t('user.userDetail')
      this.idDetails = true
      this.isUpdate = false
      this.setUpdate(row)
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.clearValidate()
      })
    },

    deleteIntergators(row) {
      this.$confirm(
        this.$tc('user.confirmDeleteTip', 1) +
          ' ' +
          row.loginName +
          this.$tc('user.confirmDeleteTip', 2),
        this.$t('user.deleteUser'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          accountApi
            .removeIntegratorsAccount({
              userId: row.id
            })
            .then(data => {
              if (data.code === '00000000') {
                this.$message({
                  type: 'success',
                  message: this.$t('common.successDelete')
                })
                this.commQuery()
              } else {
                this.$message({
                  type: 'error',
                  message: data.message
                })
              }
            })
            .catch(data => {
              this.errorMessage(data.message)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    resetPassword(row) {
      this.$confirm(
        this.$tc('user.confirmResetPwdTip', 1) +
          ' ' +
          row.loginName +
          this.$tc('user.confirmResetPwdTip', 2),
        this.$t('user.confirmResetPwd'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.showLoad()
          accountApi
            .resetIntegratorsPwd({
              userId: row.id
              // password: this.newPassword
            })
            .then(data => {
              if (data.code === '00000000') {
                this.$message({
                  type: 'success',
                  message: this.$t('user.successResetPwd')
                })
                this.closeLoad()
              } else {
                this.$message({
                  type: 'error',
                  message: data.message
                })
                this.closeLoad()
              }
            })
            .catch(data => {
              this.$message({
                type: 'error',
                message: data.message
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('user.cancelResetPwd')
          })
        })
    },
    freeze(row) {
      this.$confirm(
        this.$tc('user.confirmFreezeTip', 1) +
          ' ' +
          row.loginName +
          this.$tc('user.confirmFreezeTip', 2),
        this.$t('user.confirmFreeze'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          accountApi
            .freezeIntegratorsAccount({
              userId: row.id,
              status: 0
            })
            .then(data => {
              if (data.code === '00000000') {
                this.$message({
                  type: 'success',
                  message: this.$t('user.successFreeze')
                })
                this.commQuery()
              } else {
                this.$message({
                  type: 'error',
                  message: data.message
                })
              }
            })
            .catch(data => {
              this.$message({
                type: 'error',
                message: data.message
              })
            })
        })
        .catch(e => {
          this.$message({
            type: 'info',
            message: this.$t('user.cancelFreeze')
          })
        })
    },
    unfreeze(row) {
      this.$confirm(
        this.$tc('user.confirmUnfreezeTip', 1) +
          ' ' +
          row.loginName +
          this.$tc('user.confirmUnfreezeTip', 2),
        this.$t('user.confirmUnfreeze'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          accountApi
            .unfreezeIntegratorsAccount({
              userId: row.id,
              status: 1
            })
            .then(data => {
              if (data.code === '00000000') {
                this.$message({
                  type: 'success',
                  message: this.$t('user.successUnfreeze')
                })
                this.commQuery()
              } else {
                this.$message({
                  type: 'error',
                  message: data.message
                })
              }
            })
            .catch(data => {
              this.$message({
                type: 'error',
                message: data.message
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('user.cancelUnfreeze')
          })
        })
    },
    updateIntergators() {},
    addIntegratorsUser() {
      this.dialogTitle = this.$t('integrators.addIntegrators')
      this.idDetails = false
      this.isUpdate = false
      this.initForm()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.clearValidate()
      })
    },
    commQuery() {
      let params = {
        pager: this.pager,
        params: this.params
      }
      accountApi
        .queryIntegratorsList(params)
        .then(data => {
          if (data.code === '00000000') {
            this.interTable = data.payload.results
            this.pager.curPage = data.payload.curPage
            this.pager.pageSize = data.payload.pageSize
            this.pager.total = data.payload.totalRecords
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => this.errorMessage())
    },
    initForm() {
      this.userform.loginName = ''
      this.userform.name = ''
      this.userform.password = ''
      this.userform.secondPwd = ''
      this.userform.phone = ''
      this.userform.email = ''
      this.userform.status = 1
    },
    clearValidate() {
      this.$refs.formValidate.clearValidate()
    },
    setUpdate(row) {
      this.row = row
      this.userform.loginName = row.loginName
      this.userform.name = row.name
      this.userform.password = row.password
      this.userform.phone = this.phoneFormat(row.phone)
      this.userform.email = this.emailFormat(row.email)
      this.userform.status = row.status
    },
    showLoad() {
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('developer.saveTip'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    closeLoad() {
      if (this.loadingInstance) {
        setTimeout(() => {
          this.loadingInstance.close()
        }, 200)
      }
    }
  }
}
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/modules/comComponent/integratorsManager.vue